import { IMember } from "../../../interfaces/member.interface";

type SelectedState = { [id: string]: boolean | number[] };

// A BBS member whose name is already on the call-off is greyed out and cannot be picked again.
export const isAlreadyOnCallOff = (member: IMember, callOffMembers: IMember[]) =>
  callOffMembers.some((m) => m.name === member.name);

// Merge by id (ADO 48954). The call-off list and the BBS list come from separate fetches, so the same
// member is two different objects and a Set of objects let it in twice.
export const mergeCallOffMembers = (current: IMember[], added: IMember[]) => {
  const ids = new Set(current.map((m) => m.id));
  return [
    ...current,
    ...added.filter((m) => {
      if (ids.has(m.id)) return false;
      ids.add(m.id);
      return true;
    }),
  ];
};

// The header checkbox and drag selection must skip members already on the call-off, as a row click does.
export const withoutCallOffMembers = (
  selected: SelectedState,
  bbsMembers: IMember[],
  callOffMembers: IMember[]
): SelectedState => {
  const blocked = new Set(
    bbsMembers.filter((m) => isAlreadyOnCallOff(m, callOffMembers)).map((m) => m.id)
  );
  return Object.fromEntries(
    Object.entries(selected).filter(([id]) => !blocked.has(id))
  );
};
